import "@shopify/polaris/build/esm/styles.css"
import "@/assets/global.scss"
import "polaris-enhance/global.scss"
import "pp-draft-richtext/dist/pp-draft-richtext.css"

import { createApp } from "@shopify/app-bridge"
import { isShopifyEmbedded } from "@shopify/app-bridge-utils"
// Shopify polaris 组件
// Shopify polaris 组件的翻译文件
import React from "react"
import { createRoot } from "react-dom/client"
import { useTranslation } from "react-i18next"
import { BrowserRouter } from "react-router-dom"

import BridgeTransfer from "@/init/Entry/BridgeTransfer"
import EnvHelper from "@/utils/env-helper"
const urlSearchParams = new URLSearchParams(window.location.search)
const host = urlSearchParams.get("host") ?? ""
const apiKey = EnvHelper.shopifyApiKey || ""
import { APPEnum, getDevToken } from "react-pp-bundle"

import SentryInit from "@/initSentry"
import stores from "@/stores"
import AppBridgeHelper from "@/utils/app-bridge-helper"
import toast from "@/utils/toast"

import APIApp from "./api/app"
import AppErrorBoundary from "./layouts/AppErrorBoundary"
// 这几个方法不能删，是给react-pp-bundle用的
window.PB_ID_TOKEN = () => {
  if (import.meta.env.VITE_APP_ENV === "local") {
    return getDevToken({
      app_id: APPEnum.Returns,
      myshopify_domain: stores.UserInfoStore.data.shop,
    })
  }
  return AppBridgeHelper.getToken()
}
window.PB_TOAST = toast
window.PB_PAGE_LOADING = (loading: boolean) => {
  if (window.shopify) {
    return window.shopify.loading(loading)
  }
  return stores.CommonStore.setGlobalLoading(loading)
}

window.track = () => {}
window.t = (a: string) => a
window.pnav = () => {}
window.pnavback = () => {}
if (
  host.length > 0 &&
  window.ShopifyAppBridge?.dispatch !== null &&
  isShopifyEmbedded()
) {
  console.log("main.tsx", "初始化 ShopifyAppBridge")
  window.ShopifyAppBridge = createApp({ apiKey, host, forceRedirect: true })
  window.ShopifyAppBridgeHost = atob(host)
}

SentryInit()
const App = () => {
  const { t: _t } = useTranslation()
  // 添加tryCatch 防止报错
  window.t = (...args) => {
    try {
      return _t(...args)
    } catch (error) {
      if (typeof args[0] === "string") {
        return args[0]
      }
      return ""
    }
  }
  return (
    <React.StrictMode>
      <AppErrorBoundary>
        <BrowserRouter>
          <BridgeTransfer />
        </BrowserRouter>
      </AppErrorBoundary>
    </React.StrictMode>
  )
}

createRoot(document.getElementById("root") as HTMLElement).render(<App />)
